var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClipboardBold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_477_1031)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 3.64697H13.5C13.8978 3.64697 14.2794 3.80501 14.5607 4.08631C14.842 4.36762 15 4.74915 15 5.14697V15.647C15 16.0448 14.842 16.4263 14.5607 16.7076C14.2794 16.9889 13.8978 17.147 13.5 17.147H4.5C4.10218 17.147 3.72064 16.9889 3.43934 16.7076C3.15804 16.4263 3 16.0448 3 15.647V5.14697C3 4.74915 3.15804 4.36762 3.43934 4.08631C3.72064 3.80501 4.10218 3.64697 4.5 3.64697H6M6.75 2.14697H11.25C11.6642 2.14697 12 2.48276 12 2.89697V4.39697C12 4.81119 11.6642 5.14697 11.25 5.14697H6.75C6.33579 5.14697 6 4.81119 6 4.39697V2.89697C6 2.48276 6.33579 2.14697 6.75 2.14697Z",
    stroke: "currentColor",
    strokeWidth: 1.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_477_1031"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0 0.646973)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClipboardBold);
export default __webpack_public_path__ + "static/media/ClipboardBold.f0ab1d839be2582c47fac9f1a2720068.svg";
export { ForwardRef as ReactComponent };